import { TaskAlt, UploadFile } from '@mui/icons-material';
import { GridColDef } from '@mui/x-data-grid-pro';
import { baseColumns, getRowClass, getDeliverables, defaultSortModel } from 'pages/admin/work-order/consts';
import MarkAsCompleteButton from 'pages/work-order/mark-as-complete-button';
import UploadDeliverables from 'pages/work-order/upload-deliverables/index';

export { getRowClass, getDeliverables, defaultSortModel };

export const columns: GridColDef[] = [
	...baseColumns,
	{
		field: 'actions',
		type: 'actions',
		headerName: 'Actions',
		width: 200,
		getActions: (params) => {
			if (String(params.id).includes('auto-generated-row-null')) {
				return [];
			}
			const completed = params.row.completedAt !== null;
			return params.row.testId === null
				? [
						<MarkAsCompleteButton
							id={params.id}
							disabled={completed}
							label="Complete"
							icon={<TaskAlt />}
							closeMenuOnClick={false}
						/>,
				  ]
				: [
						<UploadDeliverables
							id={params.id}
							completed={completed}
							label="Upload"
							icon={<UploadFile />}
							closeMenuOnClick={false}
						/>,
				  ];
		},
	},
];
